export default "__VITE_ASSET__9cSxuY1p__"